import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { HttpServiceService } from 'src/app/http-service.service';
import { UtilService } from 'src/app/util.service';
import { LoaderService } from 'src/app/loader.service';
import { AlertService } from 'src/app/alert.service';

@Component({
  selector: 'app-aai-quote-details',
  templateUrl: './aai-quote-details.component.html',
  styleUrls: ['./aai-quote-details.component.scss']
})
export class AaiQuoteDetailsComponent implements OnInit {
  json:any=[]
  aaiQuote;
  clientName:any=[];
  constructor( private router:Router,
    public httpService:HttpServiceService, public alertService:AlertService,
    public util:UtilService,
    public loaderService:LoaderService) {
    this.aaiQuote = JSON.parse(localStorage.getItem('aaiQuoteDetails'))
  }
  clientData:any = {}
  ngOnInit() {
    this.clientData =  JSON.parse(localStorage.getItem('AlluserData'))
    this.getQuoteVersion(this.aaiQuote.id);
    console.log("clients")
  
    
          this.httpService.postApi(this.aaiQuote.client, 'Client/getbyid/' + this.aaiQuote.client).subscribe((res: any) => {
            if (res.success) {
              console.log(res)
              this.clientName=res.success.client[0];
            }
          });
    
   
  }

  toggleStatus(id,status){
    let data={
      isAvailable:status
    }
    this.loaderService.showLoader('Updating Please wait ..').then(()=>{
      try{
        this.httpService.postApi(data, 'Aaiquote/edit' + id).subscribe((res: any) => {
          this.loaderService.hideLoader();
          if (res["success"]) {
            this.alertService.presentAlert('Success','Successfully updated','Okay');
            this.router.navigate(['/aaiQuote-list'])
          } else {
            this.alertService.presentAlert('Error',res["error"]["message"],'Okay');
          }
        },(err)=>{
          
          this.loaderService.hideLoader();
          this.alertService.presentNetworkAlert();
         });    
      }catch(e){
        this.loaderService.hideLoader();
        this.alertService.presentAlert('Error','Something went wrong please try again','Okay');
      }
    })
  }

  delete(data) {
    this.loaderService.showLoader('Updating Please wait ..').then(()=>{
      try{
        this.httpService.postApi(data, 'Aaiquote/remove/'+data.id).subscribe((res: any) => {
          this.loaderService.hideLoader();
          if (res["success"]) {
            this.alertService.presentAlert('Success','Successfully deleted','Okay');
            this.router.navigate(['/aaiQuote-list'])
          } else {
            this.alertService.presentAlert('Error',res["error"]["message"],'Okay');
          }
        },(err)=>{
          
          this.loaderService.hideLoader();
          this.alertService.presentNetworkAlert();
         });    
      }catch(e){
        this.loaderService.hideLoader();
        this.alertService.presentAlert('Error','Something went wrong please try again','Okay');
      }
    })

  }
  edit(data) {
    console.log(data)
    localStorage.setItem('editData', JSON.stringify(data));
    this.router.navigate(['/aaiQuote-edit'])
  }

  download(data)
  {
   // window.open(this.httpService.serverUrl+'Ecquote/test/' +data.id,'_blank')
   
  }

  getQuoteVersion(data)
  {
   // console.log("clients")
   
   
          this.httpService.postApi(data, 'Aaiquote/getvesions/' + data).subscribe((res: any) => {
            if (res.success) {
              console.log(res)
               this.json = res.success.versions
              // console.log(this.versions)
            }
          });
    
   
  }
}
